import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';
import { Location } from '@angular/common';

import { ProfileService } from '../../services/profile.service';
import { UserService } from '../../services/user.service';
import { HCPGroupService } from '../../services/hcpgroup.service';
import { GroupService } from '../../services/group.service';
import { HcpQuestionnaireService } from '../../services/hcp-questionnaire.service';
import { HCPStatisticService } from '../../services/hcpstatistic.service';

import { User } from '../../models/user';
import { Study } from '../../models/study';
import { Questionnaire } from '../../models/questionnaire';
import { Answersheet } from '../../models/answersheet';
import { BasicError } from '../../models/error/error';
import { TranslateService } from '../../services/translate.service';
import {
  QuestionnaireElement, QuestionnaireElementHeadline, QuestionnaireElementYesNo,
  QuestionnaireElementSlider, QuestionnaireElementSingleChoice, QuestionnaireElementTextDate,
  QuestionnaireElementMultipleChoice, QuestionnaireElementTextString,
  QuestionnaireElementTextArea
} from '../../models/questionnaire-element';
declare var Chart: any;
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-hcp-patient-detail',
  templateUrl: './hcp-patient-detail.component.html',
  styleUrls: ['./hcp-patient-detail.component.css']
})
export class HcpPatientDetailComponent implements OnInit, AfterViewInit {
  public userId = null;
  public sort = null;
  public filters = null;
  public displayUser: User = null;
  public allStudies = [];
  public allQuestionnaires = [];
  public demographicQuestionnaires = [];
  public demographicQuestionnairesOfStudy = {};
  public demographicValues = {};
  public questionnaireOfStudy = {};
  public questionnaireElements = {};
  public questionnaireAnswersheets = {};
  public questionnaireAnswersheetsLoading = {};
  public canvasOveralls = {};
  public canvasElems = {};
  public canvasElemsDrawn = {};
  public canvasElemsCount = {};
  public legend = {};
  public debugLoadWait = false;
  public chartQueue = {};
  public sid = null;

  constructor(private route: ActivatedRoute, private location: Location,
    private profileService: ProfileService, private userService: UserService,
    private groupService: HCPGroupService, private questionnaire: HcpQuestionnaireService, private hcpstats: HCPStatisticService,
    private translate: TranslateService, private patientGroup: GroupService) { }

  ngOnInit() {
    this.allStudies = [];
    this.allQuestionnaires = [];
    this.questionnaireOfStudy = {};
    this.questionnaireElements = {};
    this.questionnaireAnswersheets = {};
    this.chartQueue = {};
    this.canvasElemsCount = {};
    this.canvasElemsDrawn = {};
    this.demographicQuestionnaires = [];
    this.demographicQuestionnairesOfStudy = {};
    this.demographicValues = {};


    this.route.paramMap.switchMap((params: ParamMap) => {
      this.userId = params.get('id');
      const studyId = params.get('sid');
      if (studyId !== undefined && studyId !== null) {
        this.sid = studyId;
      } else {
        this.sid = 1;
      }
      return this.userService.getUserDetails(this.userId);
    }).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while getting user');
      } else if (dd instanceof User) {
        this.displayUser = dd;
        this.getStudies();
      } else {
        console.log('Could not read the thread');
      }
    });
  }

  ngAfterViewInit() {
    const self = this;
  }


  public showGraphs() {
    const bootstrap_enabled = (typeof $().modal === 'function');
    const jqUI = (typeof jQuery.ui !== 'undefined');
    const dTable = (typeof $().DataTable() === 'object');
    const cc = (typeof Chart === 'function');
    if (bootstrap_enabled && jqUI && dTable && cc) {
      this.debugLoadWait = true;
    } else {
      const self = this;
      setTimeout(function () {
        self.showGraphs();
      }, 250);
    }
  }

  /**
   * Getting all studies
   */
  public getStudies() {
    this.allQuestionnaires = [];
    this.allStudies = [];

    this.patientGroup.getGroupDetail('1').subscribe(study => {
      if (study instanceof Study) {
        this.allStudies = [study];
        this.getQuestionnairesOfStudy(study);
      }
    });
  }

  /**
   * Getting all questionnaires from a specified study
   * @param study study to get questionnaires from
   */
  public getQuestionnairesOfStudy(study: Study) {
    this.questionnaire.getQuestionnairesOfStudy(study.getId()).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Failed to get all questionnaires of study');
        return;
      }

      // Having all questionnaires from study adding it to all questionnaires array
      const multiple = [];
      const demographic = []
      for (const quest of json) {
        if (quest instanceof Questionnaire) {
          if (quest.isMultiple()) {
            multiple.push(quest);
            this.getQuestionnaireElements(quest);
            this.getAnswersheetsOfUser(study, quest);
          } else {
            this.demographicQuestionnaires.push(quest);
            demographic.push(quest);
            this.getQuestionnaireElements(quest);
            this.getAnswersheetsOfUser(study, quest);
          }
        }
      }
      this.allQuestionnaires.concat(multiple);
      this.questionnaireOfStudy[study.getId().toString()] = multiple;
      this.demographicQuestionnairesOfStudy[study.getId().toString()] = demographic;
    });
  }

  /**
   * Function to get all answersheets of user based on questionnaires that exists
   */
  public getAnswersheetsOfUser(study: Study, quest: Questionnaire) {
    if (this.displayUser === null) {
      return;
    }

    if (this.questionnaireAnswersheetsLoading[quest.getId().toString()] !== undefined) {
      return;
    }

    this.questionnaireAnswersheetsLoading[quest.getId().toString()] = true;

    this.questionnaire.getAnswersheetsOfMemberAlternative(this.sid, quest.getId(),
      this.displayUser.getID(), 0, null, this.sort, this.filters).subscribe(json => {
        if (json instanceof BasicError) {
          console.log('Failed to get Answersheets of user');
          this.questionnaireAnswersheets[quest.getId().toString()] = null;
          return;
        }

        this.questionnaireAnswersheets[quest.getId().toString()] = json;
      });
  }

  /**
   * This function gets the questionnaire elements
   * @param quest questionnaire to get elements of
   */
  public getQuestionnaireElements(quest: Questionnaire) {
    // Get only elements if they aren't loaded already
    if (this.questionnaireElements[quest.getId().toString()] !== undefined) {
      return;
    }

    this.questionnaire.getQuestionnaireElements(quest).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Failed to get all elements of questionnaire');
        return;
      }

      // Saving elements of questionnaire
      this.questionnaireElements[quest.getId().toString()] = json;
    });
  }

  /**
   * Generating graphics for overall data
   * @param quest Questionnaire
   * @param id study index
   * @param jn questionnaire index
   */
  public generateOverallData(quest: Questionnaire, id, jn) {
    if (this.canvasOveralls[id + '-' + jn] !== undefined) {
      return;
    }

    // Getting all answersheets of questionnaire
    const answers = this.questionnaireAnswersheets[quest.getId().toString()];

    if (answers instanceof Array && answers.length === 0) {
      return;
    }

    // Calculating data with statistics service
    const dayData = this.hcpstats.calcAverageWeekdays(answers);
    const hourData = this.hcpstats.calcAverageHours(answers);

    let maxdays = Math.max(...dayData);

    if ((maxdays * 0.1) > 2) {
      maxdays = maxdays + (Math.floor((maxdays * 0.1)));
    } else {
      maxdays = maxdays + 2;
    }

    let maxhours = Math.max(...hourData);

    if ((maxhours * 0.1) > 2) {
      maxhours = maxhours + (Math.floor((maxhours * 0.1)));
    } else {
      maxhours = maxhours + 2;
    }


    // Data and options for days graphics
    const data = {
      labels: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      datasets: [{
        data: dayData,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
          'rgba(255,99,132,1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)'
        ],
      }]
    };

    const chartOptions = {
      scales: {
        yAxes: [{
          ticks: {
            max: maxdays,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Data for hours graph
    const labels = [];
    for (let i = 0; i < 48; i++) {
      let time = '';
      if (i % 2 === 0) {
        time = (i / 2 <= 9) ? '0' + (i / 2) + ':00' : (i / 2) + ':00';
      } else {
        time = ((i - 1) / 2 <= 9) ? '0' + ((i - 1) / 2) + ':30' : ((i - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels.push(time);
    }

    const dataHour = {
      labels: labels,
      datasets: [{
        data: hourData,
        backgroundColor:
          'rgba(54, 162, 235, 1)'
        ,
      }]
    };

    const chartOptionsHour = {
      scales: {
        yAxes: [{
          ticks: {
            max: maxhours,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const ctrl = this;

    // Getting element
    setTimeout(function () {
      const canvas = $('#questoverallDays-' + id + '-' + jn).get(0);
      const canvasH = $('#questoverallHours-' + id + '-' + jn).get(0);

      if (ctrl.canvasOveralls[id + '-' + jn] === undefined || ctrl.canvasOveralls[id + '-' + jn] === null) {
        ctrl.canvasOveralls[id + '-' + jn] = [null, null];
        ctrl.canvasOveralls[id + '-' + jn][0] = new Chart(canvas, {
          type: 'bar',
          data: data,
          options: chartOptions
        });

        ctrl.canvasOveralls[id + '-' + jn][1] = new Chart(canvasH, {
          type: 'line',
          data: dataHour,
          options: chartOptionsHour
        });
      } else {
        ctrl.canvasOveralls[id + '-' + jn][0].data.datasets[0].data = dayData;
        ctrl.canvasOveralls[id + '-' + jn][0].options.scales.yAxes[0].ticks.max = maxdays;
        ctrl.canvasOveralls[id + '-' + jn][0].update();

        ctrl.canvasOveralls[id + '-' + jn][1].data.datasets[0].data = hourData;
        ctrl.canvasOveralls[id + '-' + jn][1].options.scales.yAxes[0].ticks.max = maxhours;
        ctrl.canvasOveralls[id + '-' + jn][1].update();
      }

      setTimeout(function () {
        ctrl.showGraphs();
      }, 100);

    }, 100);
  }

  /**
   * Adding Charts to queue
   * @param type Type of graph
   * @param quest questionnaire
   * @param elem element to be drawn
   * @param id i index
   * @param jn j index
   * @param kn k index
   */
  public addChartQueue(type: String, quest: Questionnaire, elem: QuestionnaireElement, id, jn, kn) {
    if (this.chartQueue[quest.getId().toString()] === undefined || this.chartQueue[quest.getId().toString()] === null) {
      this.chartQueue[quest.getId().toString()] = {};
      this.chartQueue[quest.getId().toString()]['elems'] = [];
    }

    const ind = id + '-' + jn + '-' + kn;
    if (this.chartQueue[quest.getId().toString()][ind] !== undefined) {
      // Chart already in queue
      return;
    }

    // Adding it to queue
    this.chartQueue[quest.getId().toString()][ind] = true;
    this.chartQueue[quest.getId().toString()]['elems'].push({
      'type': type,
      'quest': quest,
      'elem': elem,
      'i': id,
      'j': jn,
      'k': kn
    });
  }

  /**
   * Drawing this questionnaires
   * @param quest questionnaire to draw
   */
  public drawCharts(quest: Questionnaire) {
    if (this.canvasElemsCount[quest.getId().toString()] !== undefined) {
      // already drawn
      return;
    }

    this.canvasElemsCount[quest.getId().toString()] = true;

    for (const drawElem of this.chartQueue[quest.getId().toString()]['elems']) {
      switch (drawElem.type) {
        case 'yesNo': this.generateYesNoChart(quest, drawElem.elem, drawElem.i, drawElem.j, drawElem.k);
          break;
        case 'singleChoice': this.generateSingleChoiceGraph(quest, drawElem.elem, drawElem.i, drawElem.j, drawElem.k);
          break;
        case 'multipleChoice': this.generateMultipleChoiceGraph(quest, drawElem.elem, drawElem.i, drawElem.j, drawElem.k);
          break;
        case 'slider': this.generatingSliderGraph(quest, drawElem.elem, drawElem.i, drawElem.j, drawElem.k);
          break;
        default: console.log('Unknown drawing property');
      }
    }
  }

  /**
   * Generating YesNoChart
   * @param quest questionnaire of graphics
   * @param elem element of questionnaire
   * @param id i index
   * @param jn j index
   * @param kn k index
   */
  public generateYesNoChart(quest: Questionnaire, elem: QuestionnaireElementYesNo, id, jn, kn) {
    const elemIdent = id + '-' + jn + '-' + kn;

    if (this.canvasElems[elemIdent] !== undefined) {
      return;
    }

    if (this.canvasElems[elemIdent] === undefined) {
      this.canvasElems[elemIdent] = [null, null, null];
    }

    // Getting all answersheets of questionnaire
    const answers = this.questionnaireAnswersheets[quest.getId().toString()];

    if (answers instanceof Array && answers.length === 0) {
      return;
    }

    // Calculating Data
    const stats = this.hcpstats.calcYesNoAnswers(elem, answers);

    const pieId = '#yes-no-pie-' + elemIdent;
    const weekId = '#yes-no-week-' + elemIdent;
    const hoursId = '#yes-no-hours-' + elemIdent;

    const max = [Math.max(...(stats.hoursYes.concat(stats.hoursNo))),
    Math.max(...stats.hoursNo), Math.max(...(stats.weekdayYes).concat(stats.weekdayNo)), Math.max(...stats.weekdayNo)];

    for (let k = 0; k < max.length; k++) {
      if ((max[k] * 0.1) > 2) {
        max[k] = max[k] + (Math.floor((max[k] * 0.1)));
      } else {
        max[k] = max[k] + 2;
      }
    }

    const labels = [];
    for (let k = 0; k < 48; k++) {
      let time = '';
      if (k % 2 === 0) {
        time = (k / 2 <= 9) ? '0' + (k / 2) + ':00' : (k / 2) + ':00';
      } else {
        time = ((k - 1) / 2 <= 9) ? '0' + ((k - 1) / 2) + ':30' : ((k - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels.push(time);
    }

    const labels2 = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    const labels3 = ['Ja', 'Nein'];

    const dataWeekYes = {
      labels: labels2,
      datasets: [{
        label: 'Ja',
        data: stats.weekdayYes,
        backgroundColor: 'rgba(75, 192, 192, 0.4)',
        borderColor: 'rgba(75, 192, 192, 1)',
      }, {
        label: 'Nein',
        data: stats.weekdayNo,
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255,99,132,1)',
      }]
    };

    const dataHoursYes = {
      labels: labels,
      datasets: [{
        label: 'Ja',
        data: stats.hoursYes,
        backgroundColor:
          'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)'
      }, {
        label: 'Nein',
        data: stats.hoursNo,
        backgroundColor:
          'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)'
      }]
    };

    const dataCount = {
      labels: labels3,
      datasets: [{
        data: stats.count,
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255,99,132,1)'
        ],
      }]
    };

    const chartOptionsHY = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[0],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const chartOptionsWY = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[2],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };


    const ctrl = this;

    // Getting element
    setTimeout(function () {
      const canvas = $(pieId).get(0);
      const canvasHY = $(hoursId).get(0);
      const canvasWY = $(weekId).get(0);


      if (ctrl.canvasElemsDrawn[elemIdent] === undefined || ctrl.canvasElemsDrawn[elemIdent] === null) {
        ctrl.canvasElemsDrawn[elemIdent] = true;

        ctrl.canvasElems[elemIdent][0] = new Chart(canvas, {
          type: 'doughnut',
          data: dataCount,
          options: chartOptions
        });


        ctrl.canvasElems[elemIdent][1] = new Chart(canvasWY, {
          type: 'bar',
          data: dataWeekYes,
          options: chartOptionsWY
        });

        ctrl.canvasElems[elemIdent][2] = new Chart(canvasHY, {
          type: 'line',
          data: dataHoursYes,
          options: chartOptionsHY
        });
      } else {

        ctrl.canvasElems[elemIdent][0].data.datasets[0].data = stats.count;
        ctrl.canvasElems[elemIdent][0].update();

        ctrl.canvasElems[elemIdent][1].data.datasets[0].data = stats.weekdayYes;
        ctrl.canvasElems[elemIdent][1].data.datasets[1].data = stats.weekdayNo;
        ctrl.canvasElems[elemIdent][1].options.scales.yAxes[0].ticks.max = max[2];
        ctrl.canvasElems[elemIdent][1].update();

        ctrl.canvasElems[elemIdent][2].data.datasets[0].data = stats.hoursYes;
        ctrl.canvasElems[elemIdent][2].data.datasets[1].data = stats.hoursNo;
        ctrl.canvasElems[elemIdent][2].options.scales.yAxes[0].ticks.max = max[0];
        ctrl.canvasElems[elemIdent][2].update();
      }
    }, 100);
  }

  /**
   * Generating SingleChoiceGraph
   * @param quest questionnaire
   * @param elem element
   * @param id i index
   * @param jn j index
   * @param kn k index
   */
  public generateSingleChoiceGraph(quest: Questionnaire, elem: QuestionnaireElementSingleChoice, id, jn, kn) {
    const elemIdent = id + '-' + jn + '-' + kn;

    if (this.canvasElems[elemIdent] !== undefined) {
      return;
    }

    if (this.canvasElems[elemIdent] === undefined) {
      this.canvasElems[elemIdent] = [null, null, null];
    }

    // Getting all answersheets of questionnaire
    const answers = this.questionnaireAnswersheets[quest.getId().toString()];

    if (answers instanceof Array && answers.length === 0) {
      return;
    }

    // Calculating Data
    const stats = this.hcpstats.calcSingleChoiceAnswers(elem, answers);

    const pieId = '#single-choice-pie-' + elemIdent;
    const weekId = '#single-choice-week-' + elemIdent;
    const hoursId = '#single-choice-hours-' + elemIdent;

    const backgrounds = ['rgba(255,99,132,1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 159, 64, 1)',
      'rgba(60, 60, 60, 1)'
    ];

    const borders = ['rgba(255,99,132,0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(255, 206, 86, 0.2)',
      'rgba(75, 192, 192, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 159, 64, 0.2)',
      'rgba(60, 60, 60, 0.2)'
    ];

    // Create Lengends
    if (this.legend[elemIdent] === undefined) {
      this.legend[elemIdent] = [];

      for (let j = 0; j < elem.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        const a = elem.getAnswers(this.translate.getSingleElementLanguage())[j];
        const l = {
          'color': backgrounds[(j % 7)],
          'text': a
        };
        this.legend[elemIdent].push(l);
      }
    }

    const labels = [];
    const bgs = [];
    const weekData = [];
    const hoursData = [];
    const max = [2, 2];

    for (let j = 0; j < elem.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
      const a = elem.getAnswers(this.translate.getSingleElementLanguage())[j];
      labels.push(a);
      bgs.push(backgrounds[(j % 7)]);

      const w = {
        label: a.toString(),
        data: stats.weekday[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      };

      const h = {
        label: a.toString(),
        data: stats.hours[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      }

      max[0] = Math.max(...(stats.weekday[j].concat([max[0]]))) + 2;
      max[1] = Math.max(...(stats.hours[j].concat([max[1]]))) + 2;

      weekData.push(w);
      hoursData.push(h);
    }

    // Pie Chart Data

    const dataCount = {
      labels: labels,
      datasets: [{
        data: stats.count,
        backgroundColor: bgs,
      }]
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };


    // Weekday chart
    const labels2 = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    const dataWeek = {
      labels: labels2,
      datasets: weekData
    };

    const chartOptionWeek = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[0],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Hours Chart
    const labels3 = [];
    for (let k = 0; k < 48; k++) {
      let time = '';
      if (k % 2 === 0) {
        time = (k / 2 <= 9) ? '0' + (k / 2) + ':00' : (k / 2) + ':00';
      } else {
        time = ((k - 1) / 2 <= 9) ? '0' + ((k - 1) / 2) + ':30' : ((k - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels3.push(time);
    }

    const dataHours = {
      labels: labels3,
      datasets: hoursData
    };

    const chartOptionHour = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[1],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };



    const ctrl = this;

    setTimeout(function () {
      const canvas = $(pieId).get(0);
      const dayC = $(weekId).get(0);
      const hourC = $(hoursId).get(0);

      if (ctrl.canvasElemsDrawn[elemIdent] === undefined || ctrl.canvasElemsDrawn[elemIdent] === null) {
        ctrl.canvasElemsDrawn[elemIdent] = true;

        ctrl.canvasElems[elemIdent][0] = new Chart(canvas, {
          type: 'doughnut',
          data: dataCount,
          options: chartOptions
        });

        ctrl.canvasElems[elemIdent][1] = new Chart(dayC, {
          type: 'bar',
          data: dataWeek,
          options: chartOptionWeek
        });

        ctrl.canvasElems[elemIdent][2] = new Chart(hourC, {
          type: 'line',
          data: dataHours,
          options: chartOptionHour
        });
      } else {
        ctrl.canvasElems[elemIdent][0].data.datasets[0].data = stats.count;
        ctrl.canvasElems[elemIdent][0].update();

        ctrl.canvasElems[elemIdent][1].data.datasets = weekData;
        ctrl.canvasElems[elemIdent][1].options.scales.yAxes[0].ticks.max = max[0];
        ctrl.canvasElems[elemIdent][1].udpate();

        ctrl.canvasElems[elemIdent][2].data.datasets = hoursData;
        ctrl.canvasElems[elemIdent][2].options.scales.yAxes[0].ticks.max = max[1];
        ctrl.canvasElems[elemIdent][2].udpate();
      }
    }, 300);
  }

  /**
   * Drawing Multiple Choice Graph
   * @param quest questionnaire
   * @param elem element
   * @param id i index
   * @param jn j index
   * @param kn k index
   */
  public generateMultipleChoiceGraph(quest: Questionnaire, elem: QuestionnaireElementMultipleChoice, id, jn, kn) {
    const elemIdent = id + '-' + jn + '-' + kn;

    if (this.canvasElems[elemIdent] !== undefined) {
      return;
    }

    if (this.canvasElems[elemIdent] === undefined) {
      this.canvasElems[elemIdent] = [null, null, null];
    }

    // Getting all answersheets of questionnaire
    const answers = this.questionnaireAnswersheets[quest.getId().toString()];

    if (answers instanceof Array && answers.length === 0) {
      return;
    }

    // Calculating Data
    const stats = this.hcpstats.calcMultipleAnswers(elem, answers);

    const pieId = '#single-choice-pie-' + elemIdent;
    const weekId = '#single-choice-week-' + elemIdent;
    const hoursId = '#single-choice-hours-' + elemIdent;

    const backgrounds = ['rgba(255,99,132,1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 159, 64, 1)',
      'rgba(60, 60, 60, 1)'
    ];

    const borders = ['rgba(255,99,132,0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(255, 206, 86, 0.2)',
      'rgba(75, 192, 192, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 159, 64, 0.2)',
      'rgba(60, 60, 60, 0.2)'
    ];

    // Create Lengends
    if (this.legend[elemIdent] === undefined) {
      this.legend[elemIdent] = [];

      for (let j = 0; j < elem.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        const a = elem.getAnswers(this.translate.getSingleElementLanguage())[j];
        const l = {
          'color': backgrounds[(j % 7)],
          'text': a
        };
        this.legend[elemIdent].push(l);
      }
    }

    const labels = [];
    const bgs = [];
    const brds = [];
    const weekData = [];
    const hoursData = [];
    const max = [2, 2];

    for (let j = 0; j < elem.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
      const a = elem.getAnswers(this.translate.getSingleElementLanguage())[j];
      labels.push(a);
      bgs.push(backgrounds[(j % 7)]);
      brds.push(backgrounds[(j % 7)]);

      const w = {
        label: a.toString(),
        data: stats.days[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      };

      const h = {
        label: a.toString(),
        data: stats.hours[j],
        backgroundColor: backgrounds[(j % 7)],
        borderColor: borders[(j % 7)]
      }

      max[0] = Math.max(...(stats.days[j].concat([max[0]]))) + 2;
      max[1] = Math.max(...(stats.hours[j].concat([max[1]]))) + 2;

      weekData.push(w);
      hoursData.push(h);
    }

    // Pie Chart Data
    const dataCount = {
      labels: labels,
      datasets: [{
        data: stats.values,
        backgroundColor: bgs,
        borderColor: brds
      }]
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Weekday chart
    const labels2 = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    const dataWeek = {
      labels: labels2,
      datasets: weekData
    };

    const chartOptionWeek = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[0],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Hours Chart
    const labels3 = [];
    for (let k = 0; k < 48; k++) {
      let time = '';
      if (k % 2 === 0) {
        time = (k / 2 <= 9) ? '0' + (k / 2) + ':00' : (k / 2) + ':00';
      } else {
        time = ((k - 1) / 2 <= 9) ? '0' + ((k - 1) / 2) + ':30' : ((k - 1) / 2) + ':30';
      }
      time = time + ' Uhr';
      labels3.push(time);
    }

    const dataHours = {
      labels: labels3,
      datasets: hoursData
    };

    const chartOptionHour = {
      scales: {
        yAxes: [{
          ticks: {
            max: max[1],
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const ctrl = this;

    setTimeout(function () {
      const canvas = $(pieId).get(0);
      const dayC = $(weekId).get(0);
      const hourC = $(hoursId).get(0);

      if (ctrl.canvasElemsDrawn[elemIdent] === undefined || ctrl.canvasElemsDrawn[elemIdent] === null) {
        ctrl.canvasElemsDrawn[elemIdent] = true;

        ctrl.canvasElems[elemIdent][0] = new Chart(canvas, {
          type: 'doughnut',
          data: dataCount,
          options: chartOptions
        });

        ctrl.canvasElems[elemIdent][1] = new Chart(dayC, {
          type: 'bar',
          data: dataWeek,
          options: chartOptionWeek
        });

        ctrl.canvasElems[elemIdent][2] = new Chart(hourC, {
          type: 'line',
          data: dataHours,
          options: chartOptionHour
        });
      } else {
        ctrl.canvasElems[elemIdent][0].data.datasets[0].data = stats.values;
        ctrl.canvasElems[elemIdent][0].update();

        ctrl.canvasElems[elemIdent][1].data.datasets = weekData;
        ctrl.canvasElems[elemIdent][1].options.scales.yAxes[0].ticks.max = max[0];
        ctrl.canvasElems[elemIdent][1].udpate();

        ctrl.canvasElems[elemIdent][2].data.datasets = hoursData;
        ctrl.canvasElems[elemIdent][2].options.scales.yAxes[0].ticks.max = max[1];
        ctrl.canvasElems[elemIdent][2].udpate();
      }
    }, 300);
  }

  /**
   * Generating graph for sliders
   * @param quest questionnarie
   * @param elem element
   * @param id i index
   * @param jn j index
   * @param kn k index
   */
  public generatingSliderGraph(quest: Questionnaire, elem: QuestionnaireElementSlider, id, jn, kn) {
    const elemIdent = id + '-' + jn + '-' + kn;

    if (this.canvasElems[elemIdent] !== undefined) {
      return;
    }

    if (this.canvasElems[elemIdent] === undefined) {
      this.canvasElems[elemIdent] = [null, null, null];
    }

    // Getting all answersheets of questionnaire
    const answers = this.questionnaireAnswersheets[quest.getId().toString()];

    if (answers instanceof Array && answers.length === 0) {
      return;
    }

    // Calculating Data
    const stats = this.hcpstats.calcSliderAnswers(elem, answers);

    const overviewId = '#slider-week-' + elemIdent;
    const hourId = '#slider-hours-' + elemIdent;

    const backgrounds = ['rgba(255,99,132,1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 159, 64, 1)',
      'rgba(60, 60, 60, 1)'
    ];

    const borders = ['rgba(255,99,132,0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(255, 206, 86, 0.2)',
      'rgba(75, 192, 192, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 159, 64, 0.2)',
      'rgba(60, 60, 60, 0.2)'
    ];

    // const random = Math.floor((Math.random() * 6));
    const random = (kn % 7);

    const bg = backgrounds[random];
    const bb = borders[random];

    // Create Legends
    if (this.legend[elemIdent] === undefined) {
      this.legend[elemIdent] = [];

      for (let j = 0; j < elem.getAnswers(this.translate.getSingleElementLanguage()).length; j++) {
        const a = elem.getAnswers(this.translate.getSingleElementLanguage())[j];
        const l = {
          'value': a.value,
          'label': a.label,
          'icon': a.icon
        };
        this.legend[elemIdent].push(l);
      }
    }

    // Ranges
    const labels = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    const max = Math.max(...stats.ranges) + 2;

    const dataRanges = {
      labels: labels,
      datasets: [{
        data: stats.ranges,
        backgroundColor: bb,
        borderColor: bg
      }]
    };

    const rangeOptions = {
      scales: {
        yAxes: [{
          ticks: {
            max: max,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    // Hours
    const labels3 = [];
    for (let k = 0; k < 24; k++) {
      let time = '';
      time = (k < 10) ? '0' + k : k + '';
      time = time + ' Uhr';
      labels3.push(time);
    }

    const dataHours = {
      labels: labels3,
      datasets: [{
        data: stats.hours,
        backgroundColor: bb,
        borderColor: bg
      }]
    };

    const chartOptionHour = {
      scales: {
        yAxes: [{
          ticks: {
            max: 100,
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    const ctrl = this;

    setTimeout(function () {
      const canvas = $(overviewId).get(0);
      const hourC = $(hourId).get(0);

      if (ctrl.canvasElemsDrawn[elemIdent] === undefined || ctrl.canvasElemsDrawn[elemIdent] === null) {
        ctrl.canvasElemsDrawn[elemIdent] = true;

        ctrl.canvasElems[elemIdent][0] = new Chart(canvas, {
          type: 'bar',
          data: dataRanges,
          options: rangeOptions
        });

        ctrl.canvasElems[elemIdent][1] = new Chart(hourC, {
          type: 'line',
          data: dataHours,
          options: chartOptionHour
        });

      } else {
        ctrl.canvasElems[elemIdent][0].data.datasets[0].data = stats.ranges;
        ctrl.canvasElems[elemIdent][0].options.scales.yAxes[0].ticks.max = max;
        ctrl.canvasElems[elemIdent][0].update();

        ctrl.canvasElems[elemIdent][1].data.datasets[0].data = stats.hours;
        ctrl.canvasElems[elemIdent][1].udpate();
      }
    }, 400);
  }

  /**
   * Returning the value of questionnaire element
   * @param study study of questionnaire
   * @param quest questionnaire
   * @param elem element to get value of
   */
  public getDemographicValue(study: Study, quest: Questionnaire, elem: QuestionnaireElement, z) {
    const id = quest.getId() + '-' + z;

    if (this.demographicValues[id] !== undefined) {
      return this.demographicValues[id];
    }

    this.demographicValues[id] = '';

    const answersList: Array<Answersheet> = this.questionnaireAnswersheets[quest.getId().toString()];

    let value = null;
    // Getting the right answersheet for this questionnaire element
    for (const answersheet of answersList) {
      const answers = answersheet.getAnswers();

      for (let i = 0; i < answers.length; i++) {
        const a: any = answers[i];
        if (elem instanceof QuestionnaireElementYesNo && a.label === elem.getLabel()) {
          const elemAnswers: Array<String> = elem.getAnswers(this.translate.getSingleElementLanguage());
          const elemValues: Array<String> = elem.getValues();
          let searchItem = '';
          if (a.value instanceof Array) {
            if (a.value[0] === false || a.value[0] === true) {
              searchItem = (a.value[0]) ? 'YES' : 'NO';
            } else {
              searchItem = a.value[0];
            }
          } else {
            if (a.value === false || a.value === true) {
              searchItem = (a.value) ? 'YES' : 'NO';
            } else {
              searchItem = a.value;
            }
          }

          const index = elemValues.indexOf(searchItem);
          const textstring = elemAnswers[index];

          (value === null) ? value = textstring : value += ', ' + textstring;
        } else if (elem instanceof QuestionnaireElementSingleChoice && a.label === elem.getLabel()) {
          const elemAnswers: Array<String> = elem.getAnswers(this.translate.getSingleElementLanguage());
          const elemValues: Array<String> = elem.getValues();
          let searchItem = '';

          if (a.value instanceof Array) {
            searchItem = a.value[0];
          } else {
            searchItem = a.value;
          }

          const index = elemValues.indexOf(searchItem);
          const textstring = elemAnswers[index];

          (value === null) ? value = textstring : value += ', ' + textstring;
        } else if (elem instanceof QuestionnaireElementMultipleChoice && a.label === elem.getLabel()) {
          const elemAnswers: Array<String> = elem.getAnswers(this.translate.getSingleElementLanguage());
          const elemValues: Array<String> = elem.getValues();
          let searchItem = '';
          let textstring = '';


          if (a.value instanceof Array) {
            for (const val of a.value) {
              const index = elemValues.indexOf(val);
              const txt = elemAnswers[index];

              (textstring === '') ? textstring = txt.toString() : textstring += ', ' + txt.toString();
            }
          } else {
            searchItem = a.value;
            textstring = elemAnswers[elemValues.indexOf(searchItem)].toString();
          }

          (value === null) ? value = textstring : value += ', ' + textstring;
        } else if (elem instanceof QuestionnaireElementSlider && a.label === elem.getLabel()) {
          (value === null) ? value = a.value : value += ', ' + a.value;
        } else if (elem instanceof QuestionnaireElementTextString && a.label === elem.getLabel()) {
          (value === null) ? value = a.value : value += ', ' + a.value;
        } else if (elem instanceof QuestionnaireElementTextArea && a.label === elem.getLabel()) {
          (value === null) ? value = a.value : value += ', ' + a.value;
        } else if (elem instanceof QuestionnaireElementTextDate && a.label === elem.getLabel()) {
          const time = (+a.value) * 1000;
          const date = new Date(time);
          let timestring = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate() + '';
          timestring += (date.getMonth() < 9) ? '.0' + (date.getMonth() + 1) : '.' + (date.getMonth() + 1);
          timestring += '.' + date.getFullYear();

          (value === null) ? value = timestring : value += ', ' + timestring;
        }
      }
    }

    if (value === null) {
      this.demographicValues[id] = 'keine Angabe';
      value = 'keine Angabe';
    } else {
      this.demographicValues[id] = value;
    }

    return value;
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/hcp-patient-detail/hcp-patient-detail.component.ts